var $407dba1ae0207730$exports = {};
// frontend/js/classViewer.js
// Presenter interface for teaching ZEconomy pedagogical sessions
// ============================================
// Translation Helper
// ============================================
function $407dba1ae0207730$var$t(key, fallback) {
    if (window.i18n && typeof window.i18n.t === 'function') {
        const result = window.i18n.t(key);
        return result !== key ? result : fallback;
    }
    return fallback;
}
// Get current language
function $407dba1ae0207730$var$getCurrentLang() {
    if (window.i18n && window.i18n.lang) return window.i18n.lang;
    return 'en';
}
// ============================================
// Utility Functions
// ============================================
function $407dba1ae0207730$var$getLessonIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('id');
}
function $407dba1ae0207730$var$escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
// ============================================
// State
// ============================================
let $407dba1ae0207730$var$currentLesson = null;
let $407dba1ae0207730$var$currentStepIndex = 0;
// ============================================
// Render Functions
// ============================================
function $407dba1ae0207730$var$renderLesson(lesson) {
    $407dba1ae0207730$var$currentLesson = lesson;
    // Update page title
    document.title = `${lesson.title} - ${$407dba1ae0207730$var$t('classes.presenter_suffix', 'Presenter')}`;
    // Header
    document.getElementById('lesson-title').textContent = lesson.title;
    document.getElementById('lesson-tagline').textContent = lesson.tagline || '';
    const levelText = lesson.level || $407dba1ae0207730$var$t('classes.mixed_level', 'mixed level');
    const minutesText = $407dba1ae0207730$var$t('classes.minutes', 'minutes');
    document.getElementById('lesson-meta').textContent = `${levelText} \u{2022} ${lesson.durationMinutes || 60} ${minutesText}`;
    // Objectives
    $407dba1ae0207730$var$renderObjectives(lesson);
    // Start with first step
    $407dba1ae0207730$var$renderStep(0);
}
function $407dba1ae0207730$var$renderObjectives(lesson) {
    const objectivesEl = document.getElementById('objectives');
    if (lesson.objectives && lesson.objectives.length) {
        const items = lesson.objectives.map((o)=>`<li>${$407dba1ae0207730$var$escapeHtml(o)}</li>`).join('');
        const objectivesTitle = $407dba1ae0207730$var$t('classes.learning_objectives', 'Learning Objectives');
        objectivesEl.innerHTML = `
      <strong>${objectivesTitle}</strong>
      <ul>${items}</ul>
    `;
    } else objectivesEl.style.display = 'none';
}
function $407dba1ae0207730$var$renderStep(index) {
    if (!$407dba1ae0207730$var$currentLesson || index < 0 || index >= $407dba1ae0207730$var$currentLesson.steps.length) return;
    $407dba1ae0207730$var$currentStepIndex = index;
    const step = $407dba1ae0207730$var$currentLesson.steps[index];
    // Create artwork lookup
    const artworkMap = {};
    ($407dba1ae0207730$var$currentLesson.artworks || []).forEach((a)=>{
        artworkMap[a.id] = a;
    });
    // Clear displays
    const imageDisplay = document.getElementById('image-display');
    const contentArea = document.getElementById('content-area');
    imageDisplay.innerHTML = '';
    contentArea.innerHTML = '';
    // Render based on step type
    switch(step.type){
        case 'pdf_document':
            $407dba1ae0207730$var$renderPdfDocument(step, imageDisplay, contentArea);
            break;
        case 'document_section':
            $407dba1ae0207730$var$renderDocumentSection(step, imageDisplay, contentArea);
            break;
        case 'art_compare':
            $407dba1ae0207730$var$renderArtCompareStep(step, artworkMap, imageDisplay, contentArea);
            break;
        case 'bridge':
        case 'content':
        case 'activity':
        case 'reflection':
            $407dba1ae0207730$var$renderContentStep(step, artworkMap, imageDisplay, contentArea);
            break;
        default:
            $407dba1ae0207730$var$renderContentStep(step, artworkMap, imageDisplay, contentArea);
    }
    // Update navigation buttons
    $407dba1ae0207730$var$updateNavigation();
}
function $407dba1ae0207730$var$renderArtCompareStep(step, artworkMap, imageDisplay, contentArea) {
    // Render side-by-side comparison images
    if (step.artworks && step.artworks.length >= 2) {
        const artwork1 = artworkMap[step.artworks[0]];
        const artwork2 = artworkMap[step.artworks[1]];
        if (artwork1 && artwork2) {
            const viewDetailsText = $407dba1ae0207730$var$t('classes.view_details', 'View Details');
            const comparisonHtml = `
        <div class="image-comparison">
          <div class="image-comparison-item">
            ${artwork1.image ? `<img src="${artwork1.image}" alt="${$407dba1ae0207730$var$escapeHtml(artwork1.title)}">` : ''}
            <div class="image-caption">
              <strong>${$407dba1ae0207730$var$escapeHtml(artwork1.title)}</strong>
              ${$407dba1ae0207730$var$escapeHtml(artwork1.artist)}, ${$407dba1ae0207730$var$escapeHtml(artwork1.date)}<br>
              ${artwork1.medium ? `${$407dba1ae0207730$var$escapeHtml(artwork1.medium)}<br>` : ''}
              ${artwork1.location ? `${$407dba1ae0207730$var$escapeHtml(artwork1.location)}<br>` : ''}
              ${artwork1.link ? `<a href="${$407dba1ae0207730$var$escapeHtml(artwork1.link)}" target="_blank" rel="noopener">${viewDetailsText}</a>` : ''}
            </div>
          </div>
          <div class="image-comparison-item">
            ${artwork2.image ? `<img src="${artwork2.image}" alt="${$407dba1ae0207730$var$escapeHtml(artwork2.title)}">` : ''}
            <div class="image-caption">
              <strong>${$407dba1ae0207730$var$escapeHtml(artwork2.title)}</strong>
              ${$407dba1ae0207730$var$escapeHtml(artwork2.artist)}, ${$407dba1ae0207730$var$escapeHtml(artwork2.date)}<br>
              ${artwork2.medium ? `${$407dba1ae0207730$var$escapeHtml(artwork2.medium)}<br>` : ''}
              ${artwork2.location ? `${$407dba1ae0207730$var$escapeHtml(artwork2.location)}<br>` : ''}
              ${artwork2.link ? `<a href="${$407dba1ae0207730$var$escapeHtml(artwork2.link)}" target="_blank" rel="noopener">${viewDetailsText}</a>` : ''}
            </div>
          </div>
        </div>
      `;
            imageDisplay.innerHTML = comparisonHtml;
        }
    }
    // Render content
    const discussionPointsText = $407dba1ae0207730$var$t('classes.discussion_points', 'Discussion Points');
    const contentHtml = `
    <h2>${$407dba1ae0207730$var$escapeHtml(step.title)}</h2>
    ${step.prompt ? `
      <div class="presenter-prompt">
        <strong>${discussionPointsText}:</strong>
        <div class="content-text">${$407dba1ae0207730$var$escapeHtml(step.prompt)}</div>
      </div>
    ` : ''}
  `;
    contentArea.innerHTML = contentHtml;
}
function $407dba1ae0207730$var$renderContentStep(step, artworkMap, imageDisplay, contentArea) {
    // Render single image if artwork is referenced
    if (step.artworks && step.artworks.length > 0) {
        const artwork = artworkMap[step.artworks[0]];
        if (artwork && artwork.image) {
            const viewDetailsText = $407dba1ae0207730$var$t('classes.view_details', 'View Details');
            const imageHtml = `
        <div class="image-single">
          <img src="${artwork.image}" alt="${$407dba1ae0207730$var$escapeHtml(artwork.title)}">
          <div class="image-caption">
            <strong>${$407dba1ae0207730$var$escapeHtml(artwork.title)}</strong>
            ${$407dba1ae0207730$var$escapeHtml(artwork.artist)}, ${$407dba1ae0207730$var$escapeHtml(artwork.date)}<br>
            ${artwork.medium ? `${$407dba1ae0207730$var$escapeHtml(artwork.medium)}<br>` : ''}
            ${artwork.location ? `${$407dba1ae0207730$var$escapeHtml(artwork.location)}<br>` : ''}
            ${artwork.link ? `<a href="${$407dba1ae0207730$var$escapeHtml(artwork.link)}" target="_blank" rel="noopener">${viewDetailsText}</a>` : ''}
          </div>
        </div>
      `;
            imageDisplay.innerHTML = imageHtml;
        }
    }
    // Render content
    let contentHtml = `<h2>${$407dba1ae0207730$var$escapeHtml(step.title)}</h2>`;
    if (step.body) contentHtml += `<div class="content-text">${$407dba1ae0207730$var$escapeHtml(step.body)}</div>`;
    if (step.instructions) {
        const activityInstructionsText = $407dba1ae0207730$var$t('classes.activity_instructions', 'Activity Instructions');
        contentHtml += `
      <div class="presenter-prompt">
        <strong>${activityInstructionsText}:</strong>
        <div class="content-text">${$407dba1ae0207730$var$escapeHtml(step.instructions)}</div>
      </div>
    `;
    }
    if (step.prompt) {
        const discussionPointsText = $407dba1ae0207730$var$t('classes.discussion_points', 'Discussion Points');
        contentHtml += `
      <div class="presenter-prompt">
        <strong>${discussionPointsText}:</strong>
        <div class="content-text">${$407dba1ae0207730$var$escapeHtml(step.prompt)}</div>
      </div>
    `;
    }
    contentArea.innerHTML = contentHtml;
}
function $407dba1ae0207730$var$renderDocumentSection(step, imageDisplay, contentArea) {
    // No images for document sections
    imageDisplay.innerHTML = '';
    // Render HTML content (not escaped - server-generated content)
    let contentHtml = `<h2>${$407dba1ae0207730$var$escapeHtml(step.title)}</h2>`;
    // Add the document content (contains HTML with footnotes)
    if (step.body) contentHtml += step.body;
    // Add reading time estimate if available
    if (step.wordCount) {
        const readingMinutes = Math.ceil(step.wordCount / 150);
        const estimatedReadingText = $407dba1ae0207730$var$t('classes.estimated_reading_time', 'Estimated reading time');
        const minText = $407dba1ae0207730$var$t('classes.min', 'min');
        contentHtml += `<div class="reading-time">${estimatedReadingText}: ${readingMinutes} ${minText}</div>`;
    }
    contentArea.innerHTML = contentHtml;
    // Scroll to top of content
    contentArea.scrollTop = 0;
}
function $407dba1ae0207730$var$renderPdfDocument(step, imageDisplay, contentArea) {
    // No images for PDF documents
    imageDisplay.innerHTML = '';
    // Render PDF viewer
    const downloadPdfText = $407dba1ae0207730$var$t('classes.download_pdf', 'Download PDF');
    const contentHtml = `
    <h2>${$407dba1ae0207730$var$escapeHtml(step.title)}</h2>
    <div class="pdf-viewer-container">
      <iframe
        src="${$407dba1ae0207730$var$escapeHtml(step.pdfUrl)}"
        class="pdf-iframe"
        title="${$407dba1ae0207730$var$escapeHtml(step.title)}"
      ></iframe>
      <div class="pdf-download-link">
        <a href="${$407dba1ae0207730$var$escapeHtml(step.pdfUrl)}" download target="_blank">
          ${downloadPdfText}
        </a>
      </div>
    </div>
  `;
    contentArea.innerHTML = contentHtml;
    // Scroll to top of content
    contentArea.scrollTop = 0;
}
// ============================================
// Navigation
// ============================================
function $407dba1ae0207730$var$updateNavigation() {
    const prevBtn = document.getElementById('prev-step');
    const nextBtn = document.getElementById('next-step');
    prevBtn.disabled = $407dba1ae0207730$var$currentStepIndex === 0;
    nextBtn.disabled = !$407dba1ae0207730$var$currentLesson || $407dba1ae0207730$var$currentStepIndex === $407dba1ae0207730$var$currentLesson.steps.length - 1;
}
function $407dba1ae0207730$var$setupNavigation() {
    document.getElementById('prev-step').addEventListener('click', ()=>{
        if ($407dba1ae0207730$var$currentStepIndex > 0) $407dba1ae0207730$var$renderStep($407dba1ae0207730$var$currentStepIndex - 1);
    });
    document.getElementById('next-step').addEventListener('click', ()=>{
        if ($407dba1ae0207730$var$currentLesson && $407dba1ae0207730$var$currentStepIndex < $407dba1ae0207730$var$currentLesson.steps.length - 1) $407dba1ae0207730$var$renderStep($407dba1ae0207730$var$currentStepIndex + 1);
    });
    // Keyboard shortcuts
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'ArrowLeft' && $407dba1ae0207730$var$currentStepIndex > 0) $407dba1ae0207730$var$renderStep($407dba1ae0207730$var$currentStepIndex - 1);
        else if (e.key === 'ArrowRight' && $407dba1ae0207730$var$currentLesson && $407dba1ae0207730$var$currentStepIndex < $407dba1ae0207730$var$currentLesson.steps.length - 1) $407dba1ae0207730$var$renderStep($407dba1ae0207730$var$currentStepIndex + 1);
    });
}
// ============================================
// Load Lesson
// ============================================
async function $407dba1ae0207730$var$loadLesson() {
    const id = $407dba1ae0207730$var$getLessonIdFromUrl();
    const lang = $407dba1ae0207730$var$getCurrentLang();
    if (!id) {
        const noLessonText = $407dba1ae0207730$var$t('classes.no_lesson_specified', 'No lesson specified.');
        document.body.innerHTML = `<p style="text-align: center; padding: 3rem;">${noLessonText}</p>`;
        return;
    }
    try {
        const res = await fetch(`/api/classes/${id}?lang=${lang}`);
        if (!res.ok) {
            if (res.status === 404) {
                const notFoundText = $407dba1ae0207730$var$t('classes.lesson_not_found', 'Lesson not found.');
                document.body.innerHTML = `<p style="text-align: center; padding: 3rem;">${notFoundText}</p>`;
            } else throw new Error(`HTTP error! status: ${res.status}`);
            return;
        }
        const lesson = await res.json();
        $407dba1ae0207730$var$renderLesson(lesson);
        $407dba1ae0207730$var$setupNavigation();
    } catch (err) {
        console.error('Error loading lesson:', err);
        const errorText = $407dba1ae0207730$var$t('classes.load_lesson_error', 'Error loading lesson. Please try again later.');
        document.body.innerHTML = `<p style="text-align: center; padding: 3rem;">${errorText}</p>`;
    }
}
// Wait for i18n to be ready, then load lesson
function $407dba1ae0207730$var$init() {
    $407dba1ae0207730$var$loadLesson();
    // Re-load lesson on language change to get translated content
    if (window.i18n) document.addEventListener(window.i18n.EVENT_NAME || 'languagechange', ()=>{
        $407dba1ae0207730$var$loadLesson();
    });
}
// Load lesson when page loads
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $407dba1ae0207730$var$init);
else $407dba1ae0207730$var$init();


//# sourceMappingURL=classview.29c50c13.js.map
